import { observer } from 'mobx-react';
import Accordion from '../../../../../Accordion';
import { ProductCollectionResource } from '../../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import ManagedByExecOnline from '../../../LearningCollectionSteps/ManagedByExecOnline';
import TableHead from '../CustomizeTableHead/TableHead';
import ExperienceRows from './ExperienceRows';
import { DraggableProvided } from '@hello-pangea/dnd';

interface Props {
  titleIcon: React.ReactNode;
  store: LearningCollectionEditStore;
  openByDefault: boolean;
  countDisplay: React.ReactNode;
  resource: ProductCollectionResource;
  provided: DraggableProvided;
}

function CollectionAccordian({
  titleIcon,
  store,
  openByDefault,
  countDisplay,
  resource,
  provided,
}: Props) {
  return (
    <div
      className="border border-gray-200 mb-2"
      data-intercom-target="collection-section"
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div className="border border-gray-200 mb-2">
        <Accordion
          title={resource.payload.name}
          titleIcon={titleIcon}
          openByDefault={openByDefault}
          className="flex items-center justify-between bg-white px-7 py-4"
        >
          <div className="overflow-auto border-t-1 border-gray-200 bg-gray-50 p-5">
            <ManagedByExecOnline />
            <p className="px-2.5 pt-5 text-sm">{countDisplay}</p>
            <table className="mt-4 w-full">
              <thead className="border-b">
                <tr>
                  <TableHead />
                </tr>
              </thead>
              <tbody className="bg-white">
                <ExperienceRows learningCollectionStore={store} resource={resource} />
              </tbody>
            </table>
          </div>
        </Accordion>
      </div>
    </div>
  );
}

export default observer(CollectionAccordian);
